import {getImageVariantByFieldname} from 'shared/lib/images';
import type {Image as IImage, ImageVariant} from 'src/models/IImage';

export const getImagesUrlsFromVariant = (images: IImage[], fieldname: string, altVariant?: string): ImageVariant[] => {
    const urls = [];

    if (Array.isArray(images))
        images.forEach((image) => {
            const imageVariant = getImageVariantByFieldname(image, fieldname, altVariant);

            if (imageVariant)
                urls.push({
                    url: imageVariant.url,
                    id: image.id,
                    meta: imageVariant.meta,
                });
        });

    return urls;
};